// extracted by mini-css-extract-plugin
module.exports = {"ModalPadding":"0.5rem","modalBody":"ModalBody_modalBody__21IEe"};